if (typeof BestSellersCarousel === 'undefined') {
    class BestSellersCarousel extends HTMLElement {
        constructor() {
            super();
            this.handleTabPanelChanged = this.handleTabPanelChanged.bind(this);
        }

        connectedCallback() {

            const swiperContainer = this.querySelector('.swiper');
            if (!swiperContainer || this.swiper) return;

            whenReady('Swiper', () => {
                try {

                    this.swiper = new Swiper(swiperContainer, {
                        a11y: true,
                        slidesPerView: "auto",
                        // loop: true,
                        spaceBetween: 20,
                        pauseOnMouseEnter: false,
                        watchSlidesProgress: true,
                        preventClicks: false,
                        preventClicksPropagation: false,
                        navigation: {
                            nextEl: this.querySelector('.swiper-next'),
                            prevEl: this.querySelector('.swiper-prev')
                        },
                        scrollbar: {
                            el: this.querySelector('.swiper-scrollbar'),
                            draggable: true,
                            dragSize: 52,
                        },
                        mousewheel: {
                            enabled: !window.isSafari(),
                            forceToAxis: window.isSafari() ? false : true,
                            thresholdDelta: 10
                        },
                        modules: [Swiper.Mousewheel, Swiper.Autoplay, Swiper.A11y, Swiper.Scrollbar, Swiper.Navigation].filter(Boolean),
                        breakpoints: {
                            641: {
                                scrollbar: {
                                    dragSize: 92,
                                }
                            },
                            992: {
                                scrollbar: {
                                    dragSize: 140,
                                }
                            }
                        }
                    });


                } catch (error) {
                    console.error('Failed to initialize Swiper:', error);
                }
            });

            document.addEventListener('tabby:panel:changed', this.handleTabPanelChanged);
        }

        disconnectedCallback() {
            document.removeEventListener('tabby:panel:changed', this.handleTabPanelChanged);

            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }

        handleTabPanelChanged(event) {
            if (!this.swiper) return;

            const activeContent = event?.detail?.activeContent;
            if (!activeContent || !activeContent.contains(this)) return;

            requestAnimationFrame(() => {
                this.swiper.update();
                if (typeof this.swiper.updateAutoHeight === 'function') {
                    this.swiper.updateAutoHeight(0);
                }
            });
        }

    }

    if (!window.customElements.get('best-sellers-carousel')) {
        window.customElements.define('best-sellers-carousel', BestSellersCarousel);
    }
}